import { IUserProfile } from "../../../../types/userTypes";

export const nullUserProfile: IUserProfile = {
  id: 0,
  isUserVerified: false,
  userRoles: [],
  userId: 0,
  firstName: null,
  status: null,
  nationality: null,
  isPanVerified: null,
  isOrgPanVerified: null,
  isAadhaarVerified: null,
  isAadhaarMasked: null,
  isBankVerified: null,
  stateId: null,
  countryId: null,
  incomeType: null,
  bankId: null,
  annualIncome: null,
  residentStatus: null,
  immediateInvestmentAmount: null,
  annualInvestmentAmount: null,
  expectedReturns: null,
  investmentPeriod: null,
  payout: null,
  financialUnderwritingLimit: null,
  referrerId: null,
  insurerId: null,
  lastName: null,
  gender: null,
  email: null,
  dob: null,
  pan: null,
  aadhar: null,
  address: null,
  currentAddress: null,
  permanentAddress: null,
  city: null,
  pinCode: null,
  altMobile: null,
  education: null,
  occupation: null,
  jobTitle: null,
  bankAccountNumber: null,
  bankBranchName: null,
  accountType: null,
  IFSCCode: null,
  UPICode: null,
  MICR: null,
  CKYCNumber: null,
  EIANumber: null,
  PANDocument: null,
  AADHARDocument: null,
  AADHARBackDocument: null,
  passportDocument: null,
  photo: null,
  bankStatement: null,
  ITRCopy: null,
  cancelledCheck: null,
  sourceOfFund: null,
  industryType: null,
  nameOfOrganization: null,
  addressOfOrganization: null,
  orgMemoDocument: null,
  orgBalanceSheetDocument: null,
  orgLossDocument: null,
  orgIncomeDocument: null,
  orgRegistrationDocument: null,
  orgAddressDocument: null,
  orgPanDocument: null,
  orgPan: null,
  orgRegistrationDate: null,
  mobile: null,
  alternatePhone: null,
  rejectionReason: null,
  natureOfDuties: null,
  relativeName: null,
  isSmoker: null,
  isPoliticallyExposed: null,
  itReturnReceived: null,
  role: null,
  createdAt: null,
  updatedAt: null,
  maritalStatus: null,
  nominees: [],
  referralCode: null,
  currentRole: null,
  countryCode: null,
  phoneNumber: null,
  userType: null,
  is_profile_complete: null,
};
